export { default } from "./BottomNavigationAction.mjs";
export { default as bottomNavigationActionClasses } from "./bottomNavigationActionClasses.mjs";
export * from "./bottomNavigationActionClasses.mjs";